import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './Logo.css';
import axios from 'axios';
import { ApiConstant } from '../../../../constants';
import { get } from 'lodash';

function Logo (props) {
  const { size, partnerLogoId } = props;
  const style = useMemo(() => ({ fontSize: size || 20 }), [size]);
  const [partnerLogoURL, setPartnerLogoURL] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (partnerLogoId) {
      setLoading(true);
      axios
        .post(`${ApiConstant.BASE_URL}common/`, { action: 'GET_PARNER_LOGO_URL', logo_id: partnerLogoId })
        .then((res) => setPartnerLogoURL(get(res, 'data.url')))
        .catch(console.error)
        .finally(() => setLoading(false));
    } else {
      setPartnerLogoURL(null);
    }
  }, [partnerLogoId]);

  if (partnerLogoId) {
    if (partnerLogoURL && !loading) {
      return <img className="turing-ui-v2-partner-logo" src={partnerLogoURL} />;
    } else {
      return null;
    }
  } else {
    return <span className="turing-ui-v2-logo" style={style}>Turing</span>;
  }
}

Logo.propTypes = {
  size: PropTypes.number,
  partnerLogoId: PropTypes.any
};

export default React.memo(Logo);
